import React from "react";
import { useIntl } from "react-intl";
import OwBadge from "../OwBadge/OwBadge";

type Props = {
    stepName?: string | null;
};

const InProductionBadge: React.FC<Props> = (props) => {
    const intl = useIntl();
    const label = intl.formatMessage({ id: "in_production" }) + (props.stepName ? ` — ${props.stepName}` : "");

    return <OwBadge title={label} bgColor={"bg-warning"} skipTranslate={true} />;
};

export default InProductionBadge;
